import React from "react"
import { ConditionalLayout } from "containers"
import { Tabs, Select } from "components"

const compareFn = (props) => {
  // the Measure component just calculates the height of element with padding
  // height of element will be 50 px-ish so 90 would be good for detecting two lines
  return props.secondChildDimensions.height > 90
}

const TabsResponsive = props => {
  return props.dropdown ?
    (
      <ConditionalLayout compareFn={compareFn}>
        <Select {...props} margin={false} />
        <Tabs {...props} />
      </ConditionalLayout>
    )
    :
    (
      <Tabs scrolling {...props} />
    )
}

export default TabsResponsive



// WEBPACK FOOTER //
// ./src/components/tabs-responsive/index.jsx